import React from 'react';
import styles from './AddIpo.module.css';

/**
 * One labelled input plus its validation message, used by all four Investment
 * Services forms so the error styling and layout stay identical across them.
 *
 * Renders a <select> when `options` is given and a <textarea> when `textarea`
 * is set; everything else is a plain input of the requested `type`.
 */
const FormField = ({
  label,
  name,
  value,
  onChange,
  error,
  type = 'text',
  options = null,
  textarea = false,
  placeholder = '',
  step,
  fullWidth = false,
  required = false,
}) => {
  const controlClass = `${styles.input} ${error ? styles.inputError : ''}`;
  const shared = { name, value: value ?? '', onChange, className: controlClass };

  return (
    <div className={styles.formGroup} style={fullWidth ? { gridColumn: '1 / -1' } : undefined}>
      <label className={styles.label}>
        {label}{required ? ' *' : ''}
      </label>

      {options ? (
        <select {...shared}>
          {options.map((option) => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>
      ) : textarea ? (
        <textarea {...shared} rows={3} style={{ resize: 'vertical' }} placeholder={placeholder} />
      ) : (
        <input
          {...shared}
          type={type}
          step={step}
          placeholder={placeholder}
          className={`${controlClass} ${type === 'date' ? styles.dateInput : ''}`}
        />
      )}

      {error ? <span className={styles.fieldError}>{error}</span> : null}
    </div>
  );
};

export default FormField;
